<template>
    <div>
        <h2 class="text-capitalize">{{ $t('menu.team') }}</h2>
        <ul class="teammembers flex -wrap">
            <li v-for="(member, index) in members" :key="'team_' + index">
                <img v-if="member.afbeelding1" loading="lazy" :\src="member.afbeelding1" class="team__img"
                    :alt="inlinedata(member, 'naam', currentlang)" />
                <h2 itemprop="title">{{ inlinedata(member, 'naam', currentlang) }}</h2>
                <div class="article-text" itemprop="description">
                    <div v-html="inlinedata(member, 'tekst', currentlang)"></div>
                    <br />
                    <a v-if="member.email" :href="'mailto:' + member.email" class="button">
                        {{ inlinedata(member, 'email_knop', currentlang) || 'E-mail' }}
                    </a>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Team',
    computed: {
        members() {
            return this.webdata('team');
        },
        currentlang() {
            return this.$store.getters['Language/current'];
        },
    },
};
</script>

<style>
.teammembers li {
    flex: 0 1 25%;
    margin-bottom: 4rem;
    padding-right: 2.4rem;
    min-width: 33rem;
}

.team__img {
    border-radius: 0.8rem;
    max-width: 14rem;
    width: 100%;
    margin-bottom: 1.5rem;
}
</style>
